import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/orders.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const Orders = withSvgProps(Svg)
